import { useState } from "react";
import { Form as AntdForm, message } from "antd";
import { Modal, Form } from "../..";
import { USER_CAR_FORM } from "../../../data/forms";
import { IsEnable } from "../../../enums";

// Хэрэглэгч өөрөө машинаа нэмэх modal.
export const USER_CAR_URL = "/user/addeditcar";

const Index = ({ open, onClose, ...props }) => {
  const [form] = AntdForm.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = (values) => {
    if (props?._auth?.user?.phone === "demo") {
      message.error(props?.translate("main.democontrol"));
      return;
    }
    const body = {
      ...values,
      imei: values?.imei?.toString()?.trim(),
      // Админаас тохируулдаг талбаруудын default утга
      isnewbroker: 1,
      islock: 0,
      ismotor: 0,
      isenable: IsEnable.Идэвхтэй,
    };
    setLoading(true);
    props
      ?.request({
        url: USER_CAR_URL,
        method: "POST",
        body,
        ismessage: true,
      })
      ?.then((res) => {
        setLoading(false);
        if (res?.success) {
          props?.request({
            url: `/user/cars`,
            model: "carsinfo",
            method: "POST",
          });
          form.resetFields();
          onClose && onClose(res?.data);
        }
      });
  };

  return (
    <Modal
      title={props?.translate("main.addcar")}
      open={open}
      onClose={onClose}
      width={600}
      isShowFooter={false}
      height={"85%"}
    >
      {open ? (
        <Form
          {...props}
          name="usercar"
          data={USER_CAR_FORM}
          form={form}
          loading={loading}
          handleSave={handleSave}
          initialValues={{ id: 0 }}
          className="mt-2"
          btnTitle="main.save"
        />
      ) : null}
    </Modal>
  );
};

export default Index;
